module.exports = __webpack_public_path__ + "static/document-137c4364baf7445e17b98bb3093d8ec2.svg";